module.exports = __webpack_public_path__ + "static/media/availability-slide-8.ae32e920.jpg";